import { useState } from 'react';
import classes from './NavBar.module.css';
import Navigation from './Navigation';
import MobileNavigation from './MobileNavigation';
import HomeIcon from './HomeIcon';
import Button from '../components/Button';
import { COMPANY } from '../../Const';

const NavBar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className={classes.NavBar}>
      <div className={classes.Inner}>
        <HomeIcon />
        <Navigation />
        <div className={classes.Actions}>
          <a className={classes.Tel} href={`tel:${COMPANY.tel}`}>
            お電話でのご相談
            <b>{COMPANY.tel}</b>
          </a>
          <Button size="small" href="/contact">
            お問い合わせ
          </Button>
          <button
            type="button"
            className={`${classes.Hamburger} ${open ? classes.Open : ''}`}
            aria-label="メニュー"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      {open && <MobileNavigation onNavigate={() => setOpen(false)} />}
    </header>
  );
};

export default NavBar;
